import EmptyCell from 'components/table/components/EmptyCell';

// A line of a record's information: its label over its value, or a dash.
export const RecordField = ({ label, children }) => (
  <div className="border-b border-gray-100 py-2.5 last:border-0">
    <p className="text-xs text-gray-700">{label}</p>
    <div className="text-sm text-gray-900">{children || <EmptyCell />}</div>
  </div>
);

/**
 * The information of a record: `fields` are { label, value }; those after
 * `shown` wait behind « Voir plus » (`more`, `onMore` and the two labels).
 */
const RecordFields = ({ fields, shown = fields.length, more, onMore, moreLabel, lessLabel }) => (
  <>
    {fields.slice(0, more ? fields.length : shown).map((field) => (
      <RecordField key={field.label} label={field.label}>
        {field.value}
      </RecordField>
    ))}
    {fields.length > shown && (
      <button
        type="button"
        onClick={onMore}
        className="mt-3 w-full rounded-md border border-gray-100 bg-white px-4 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-100"
      >
        {more ? lessLabel : moreLabel}
      </button>
    )}
  </>
);

export default RecordFields;
